// extracted by mini-css-extract-plugin
module.exports = {"hidden_input":"legitimatiebewijs-modal_hidden_input__3Fyas"};